export default __webpack_public_path__ + "media/images/svg-bend-3dff6b8d21b5791d3074830575f626ff.svg";